import * as React from 'react';
import { useColorScheme } from '@mui/joy/styles';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import IconButton from '@mui/joy/IconButton';
import Stack from '@mui/joy/Stack';
import Avatar from '@mui/joy/Avatar';
import Input from '@mui/joy/Input';
import Button from '@mui/joy/Button';
import Tooltip from '@mui/joy/Tooltip';
import Dropdown from '@mui/joy/Dropdown';
import Menu from '@mui/joy/Menu';
import MenuButton from '@mui/joy/MenuButton';
import MenuItem from '@mui/joy/MenuItem';
import ListDivider from '@mui/joy/ListDivider';
import Drawer from '@mui/joy/Drawer';
import ModalClose from '@mui/joy/ModalClose';
import DialogTitle from '@mui/joy/DialogTitle';

import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import BookRoundedIcon from '@mui/icons-material/BookRounded';
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import BugReportRoundedIcon from '@mui/icons-material/BugReportRounded';
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';


import Navigation from './Navigation';
import ColorSchemeToggle from '@components/ColorSchemeToggle';
import { Link, useLocation } from 'react-router-dom';
import { Badge, ListItem, SvgIcon } from '@mui/joy';
import { useAuth } from '@providers/AuthProvider';
import MaestroLoader from '@components/MaestroLoader';
import Notifications from '@components/Notifications';
import Search from '@components/Search';
import CommunityJumper from '@components/CommunityJumper';
import ReportButtons from '@components/ReportButtons';
import { maestroIcon } from '@utils/assets';

export default function ConductorHeader() {
  const [open, setOpen] = React.useState(false);
  const {user, signOut, can} = useAuth();
  const { hash, pathname, search } = useLocation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'space-between',
      }}
    >
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={1}
        sx={{ display: { xs: 'flex', md: 'flex' } }}
      >
        {/* <Link to={`/dashboard`}> */}
        {/* <Tooltip title="Go to Dashboard" variant="outlined"> */}
            <IconButton
            size="md"
            variant="outlined"
            color="neutral"
          sx={{
                display: 'inline-flex',// { xs: 'none', md: 'inline-flex' },
                borderRadius: '50%',
            }}
            >
                <img
                    src={maestroIcon}
                    style={{
                      // width: 'calc(var(--IconButton-size) - 0.5rem)'
                      maxWidth: '100%',
                    }}
                />
            </IconButton>
        {/* </Tooltip> */}
        {/* </Link> */}

        <Box sx={{display:{ xs: 'none', md: 'inline-flex' }}}>
          {/* <Typography>Conductor</Typography> */}
        </Box>

      </Stack>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 1.5,
          alignItems: 'center',
        }}
      >
        <ReportButtons/>
      </Box>
    </Box>
  );
}
